// Meta route-specifici per le pagine pubbliche prive di <SEO> proprio (legali/FAQ).
// Un'unica mappa: aggiungere una rotta qui invece di duplicare stringhe nelle pagine.
export interface PageMetaEntry {
  ns: string;
  titleKey: string;
  descKey: string;
}

export const STATIC_PAGE_META: Record<string, PageMetaEntry> = {
  terms: { ns: 'legal', titleKey: 'seo_terms_title', descKey: 'seo_terms_desc' },
  privacy: { ns: 'legal', titleKey: 'seo_privacy_title', descKey: 'seo_privacy_desc' },
  disclaimer: { ns: 'legal', titleKey: 'seo_disclaimer_title', descKey: 'seo_disclaimer_desc' },
  faq: { ns: 'legal', titleKey: 'seo_faq_title', descKey: 'seo_faq_desc' },
  cookies: { ns: 'legal', titleKey: 'seo_cookies_title', descKey: 'seo_cookies_desc' },
  refund: { ns: 'legal', titleKey: 'seo_refund_title', descKey: 'seo_refund_desc' },
  'affiliate-terms': { ns: 'legal', titleKey: 'seo_affiliate_title', descKey: 'seo_affiliate_desc' },
};

// Normalizza il pathname togliendo il prefisso lingua e gli slash ai bordi.
// '/it/terms' e '/terms' -> 'terms'; '/it' e '/' -> null.
export function resolvePageKey(pathname: string): string | null {
  const withoutLang = pathname.replace(/^\/[a-z]{2}(?=\/|$)/, '');
  const clean = withoutLang.replace(/^\/+|\/+$/g, '');
  return clean || null;
}
